angular.module('picmonicng').factory('SearchHistoryResource', [
  '$resource',
  function ($resource) {
    return $resource('/api/v3/search_history', { resource: '@resource' });
  },
]);
